import { Amenity } from 'components/filters/types';

export const isSeoAmenityFilter = (amenity: Amenity): boolean => {
  return [ Amenity.Parking, Amenity.Elevator, Amenity.Balcony ].includes(amenity);
};
